'use client'

import NextImage from 'next/image'

import { Button } from '@/core/components/button'
import { WordSpinner } from './word-spinner.client'

export function ProductHero() {
  return (
    <section className="bg-soft-white grid grid-rows-[auto_1fr] min-h-[600px]">
      <div className="h-24" />
      <div className="py-20 lg:py-32">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="space-y-4">
                <h1 className="text-4xl lg:text-6xl font-bold text-navy leading-tight">
                  Join a Community <span className="block">Marketplace for</span>
                  <WordSpinner />
                </h1>
                <p className="text-lg text-muted-foreground max-w-lg">
                  Connect with your local community, discover trusted goods and services, and build
                  meaningful relationships through shared interests.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button variant="gradient" size="lg" className="text-lg px-8 py-4">
                  Join a Hive
                </Button>
                <Button variant="cta-secondary" size="lg" className="text-lg px-8 py-4">
                  Learn More
                </Button>
              </div>
              <div className="flex items-center space-x-6 text-sm text-muted-foreground">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-accent rounded-full" />
                  <span>Free to join</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-accent rounded-full" />
                  <span>3,000+ active hives</span>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="relative z-10">
                <NextImage
                  src="/assets/hero-phone.jpg"
                  width={512}
                  height={512}
                  sizes="448px"
                  alt="HubHive Mobile App"
                  className="w-full max-w-md mx-auto drop-shadow-2xl h-auto"
                />
              </div>
              <div className="absolute top-10 -right-10 w-32 h-32 bg-gradient-primary rounded-full opacity-20 blur-xl" />
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-vibrant-cyan rounded-full opacity-10 blur-2xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
